<template>
  <v-container fluid>
    <v-row>
      <!-- BUTTONS: NEW & OPEN -->
      <v-col>
        <!-- BUTTON + DIALOG NEW -->
        <dialog-new-project
          v-if="creationAccess"
          @newProject="newProject"
        />
        <!-- SPACER -->
        <span
          v-if="creationAccess"
          class="mx-2"
        />
        <!-- BUTTON + DIALOG OPEN -->
        <dialog-open-project
          icon="mdi-file-document-edit-outline"
          :text="$t('project.open')"
          :only-icon="false"
          :is-rounded="true"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <!-- DASHBOARD ITEMS -->
        <v-container
          grid-list-md
          justify-start
          fluid
          fill-height
        >
          <v-row>
            <v-flex
              v-if="creationAccess"
              sm12
              md5
              lg3
            >
              <!-- DIMENSIONS LIST -->
              <dimensions-list @dimensionSelected="newProject" />
            </v-flex>
            <v-flex
              sm12
              md7
              lg6
            >
              <!-- PROJECTS GRID LIST -->
              <projects-grid @openProject="loadProject" />
            </v-flex>
            <v-flex
              sm12
              md5
              lg3
            >
              <!-- PLAYERS STATUS -->
              <players-list />
            </v-flex>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Components
import dialogNewProject from "./Dialog/DialogNewProject";
import dialogOpenProject from "./Dialog/DialogOpenProject";
import dimensionsList from "./HomePage/DimensionsList";
import projectsGrid from "./HomePage/ProjectsGrid";
import playersList from "./HomePage/PlayersList";

// Connectors
import { ProfileFavouriteConnector } from "./Database/ProfileFavouriteConnector.js";

export default {
  components: {
    dialogNewProject,
    dialogOpenProject,
    dimensionsList,
    projectsGrid,
    playersList,
  },
  data() {
    return {
      favConnector: new ProfileFavouriteConnector(this.$store.state.user),
      creationAccess: false,
      playerMode: false,
      timerMqtt: "",
    };
  },
  created() {
    document.title = this.$t("appname");
    this.$store.dispatch("setHeader", this.$t("navbar.home"));
  },
  mounted() {
    if (this.playerMode) {
      this.$router.push({ path: "/player" });
    }

    this.creationAccess = this.$store.state.user.permissions.includes("1|");
  },
  methods: {
    loadProject(projectData) {
      this.favConnector.insertHistProjectByFilepath(projectData.savePath.replace("./", ""));
      this.$store.dispatch("open", projectData).project;
      this.$router.push({ path: "/project/1" });
    },
    newProject(name, projectData) {
      this.favConnector
        .insertHistDimension(projectData.width, projectData.height)
        .then(() => {
          const w = projectData.width;
          const h = projectData.height;

          this.$store.dispatch("new", {
            name: name,
            properties: { width: w, height: h },
          }).project;
          this.$router.push({ path: "/project/1" });
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>

<style>
#btn-container .theme--dark.dash-btn {
  background-color: #424242;
}

#btn-container .theme--light.dash-btn {
  background-color: #dedede;
}
</style>
